import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import Chart from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import { Box } from '@mui/material';
import { ApexChartParams, IChartProps, TreeContext } from 'views';
import { Tree } from 'stores';
import { Icon } from 'components';
import ReactDOMServer from "react-dom/server";
import styled from 'styled-components';


export interface ITimeChartProps extends IChartProps {
};

const previewData = [
  {
    data: [
      {
        x: 'Category A', y: [54, 66, 69, 75, 88]
      },{
        x: 'Category B', y: [43, 65, 69, 76, 81]
      },{
        x: 'Category C', y: [31, 39, 45, 51, 59]
      },{
        x: 'Category D', y: [39, 46, 55, 65, 71]
      }
    ]
  }
];

const previewLabels: string[] = ["Company A", "Company B", "Company C", "Company D"];

export const TimeChart = observer((props: ITimeChartProps): JSX.Element => {
  const { preview }  = props;
  const { t }        = useTranslation();
  const tree: Tree   = React.useContext(TreeContext);

  const { data, labels } : {data: ApexAxisChartSeries, labels: string[]} = preview ? 
    {data: previewData, labels: previewLabels} : tree.getChartData('duration');

  const options: ApexOptions = {
    noData: {
      text: t("no_chart_data"),
    },
    dataLabels: {
      style: {
        colors: [
          function (params: ApexChartParams) {
            if (params.series[params.seriesIndex][params.dataPointIndex] === 0 ) {
              return "black"; 
            } else {
              return "white";
            }
          },
        ],
      }
    },
    chart: {
      id:      t('time_chart_title'),
      width:   "100%",
      height:  "100%",
      toolbar: {
        show: !preview,
        export: {
          // csv: {
          //   filename: t('time_chart_title'),
          //   columnDelimiter: ";"
          // },
          svg: { 
            filename: t('time_chart_title'),
          },
          png: { 
            filename: t('time_chart_title'),
          },
        },
        tools: {
          download: ReactDOMServer.renderToString(<Icon size='size-18' iconId='download'/>),
        }
      },
    },
    colors: ['#007672', '#00AB84', '#c6007e', '#833177','#FF7500'],
    tooltip: {
      enabled: !preview,
    },
    title: {
      text: t('time_chart_title'),
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    states: {
      hover: {
        filter: {
          type: preview ? 'none' : undefined,
        },
      },
    },
    yaxis: {
      labels: {
        show: Boolean(labels?.length)
      },
    },
    xaxis: {
      tickPlacement: 'on',
      labels: {
        trim: true,
        hideOverlappingLabels: true,
        show: Boolean(labels?.length),
      },
    }
  };
  return (
    <StyledBox height="100%" width="100%"> {/* Chart needs a not flex container to stretch as expected */}
      <Chart
        type    = "boxPlot"
        series  = {data}
        options = {options}
        width   = "100%"
        height  = "100%"
      />
    </StyledBox>
  );
});

const StyledBox = styled(Box)`
  .apexcharts-menu-item.exportCSV {
    display: none;
  }
`;